"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableTableBasic = void 0;
var lodash_1 = __importDefault(require("lodash"));
var React = __importStar(require("react"));
var DateUtil_1 = require("../../utils/DateUtil");
var EditableHeadColumn_1 = require("./EditableHeadColumn");
var EditableRows_1 = require("./EditableRows");
var SharedComponents_1 = require("./SharedComponents");
var EditableTableBasic = /** @class */ (function (_super) {
    __extends(EditableTableBasic, _super);
    function EditableTableBasic(props) {
        var _this = _super.call(this, props) || this;
        _this.state = _this.mapPropsToState(_this.props);
        _this.getFormatText = _this.getFormatText.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onUpdate = _this.onUpdate.bind(_this);
        _this.getError = _this.getError.bind(_this);
        return _this;
    }
    EditableTableBasic.prototype.UNSAFE_componentWillReceiveProps = function (props) {
        this.setState(this.mapPropsToState(props));
    };
    EditableTableBasic.prototype.mapPropsToState = function (props) {
        var columns = props.columns, data = props.data;
        var requireColumns = lodash_1.default.filter(columns, function (column) {
            return column.editable;
        });
        var state = {
            data: data ? lodash_1.default.cloneDeep(data) : [],
            requireFields: requireColumns.map(function (column) {
                return column.columnKey;
            }),
        };
        return state;
    };
    EditableTableBasic.prototype.render = function () {
        var _a = this.props, columns = _a.columns, editMode = _a.editMode, onChange = _a.onChange, responsive = _a.responsive, enableHtmlEditor = _a.enableHtmlEditor, htmlEditorMode = _a.htmlEditorMode, toolbarConfiguration = _a.toolbarConfiguration, rest = __rest(_a, ["columns", "editMode", "onChange", "responsive", "enableHtmlEditor", "htmlEditorMode", "toolbarConfiguration"]);
        var _b = this.state, data = _b.data, requireFields = _b.requireFields;
        var className = this.props.className || '';
        if (responsive) {
            className += ' table-responsive';
        }
        return (React.createElement(SharedComponents_1.TableMargin, { className: className },
            React.createElement(SharedComponents_1.StyledTable, __assign({ editMode: editMode, responsive: responsive }, rest),
                React.createElement(SharedComponents_1.TableHead, null,
                    React.createElement(SharedComponents_1.TableRow, null, columns.map(function (column, index) {
                        return (React.createElement(EditableHeadColumn_1.EditableHeadColumn, { key: "editable-head-column-".concat(index), editable: column.editable, editMode: editMode, minWidth: column.minWidth }, column.label));
                    }))),
                React.createElement(SharedComponents_1.TableBody, null,
                    React.createElement(EditableRows_1.EditableRows, { editMode: editMode, data: data, columns: columns, existingEditable: true, enableHtmlEditor: enableHtmlEditor, htmlEditorMode: htmlEditorMode, toolbarConfiguration: toolbarConfiguration, requireFields: requireFields, onFormatText: this.getFormatText, onChange: this.onChange, onUpdate: this.onUpdate, getError: this.getError })))));
    };
    // Function to format the date column
    // Show the replace button if there're any duplicated new records to column(replaceButton=true)
    EditableTableBasic.prototype.getFormatText = function (column, record) {
        if (column.dataType === 'date' && record[column.columnKey]) {
            var date = new Date(record[column.columnKey]);
            return DateUtil_1.DateUtil.formatDateToLocal(date, column.format);
        }
        return record[column.columnKey];
    };
    EditableTableBasic.prototype.onChange = function (record) {
        var onChange = this.props.onChange;
        // TODO: figure out where the data is getting mutated before we capture it here
        // TODO: once the above is fixed, do a comparison to state data before triggering change
        var index = lodash_1.default.findIndex(this.state.data, { uniqueId: record.uniqueId });
        if (index > -1 && onChange) {
            onChange(record);
        }
    };
    EditableTableBasic.prototype.onUpdate = function (record) {
        var onUpdate = this.props.onUpdate;
        var data = this.state.data;
        var index = lodash_1.default.findIndex(data, { uniqueId: record.uniqueId });
        if (index > -1) {
            data.splice(index, 1, record);
        }
        this.setState({ data: data }, function () {
            if (onUpdate) {
                onUpdate(data);
            }
        });
    };
    // Function to show error or yes icon in cell
    EditableTableBasic.prototype.getError = function (column, record) {
        // Check the required fields
        if (this.props.showErrors) {
            if (!record[column.columnKey] || record[column.columnKey] === '') {
                var requiredMessage_1 = column.requiredMessage;
                if (requiredMessage_1) {
                    var regex = /[$]\S+/g;
                    var needToBeReplacedKeys = column.requiredMessage.match(regex);
                    if (needToBeReplacedKeys && needToBeReplacedKeys.length > 0) {
                        needToBeReplacedKeys.forEach(function (key) {
                            var columnKey = key.replace('$', '');
                            requiredMessage_1 = requiredMessage_1.replace(key, record[columnKey]);
                        });
                    }
                    return {
                        hasError: true,
                        errorType: 'required',
                        message: requiredMessage_1,
                    };
                }
            }
        }
        return {
            hasError: false,
            errorType: '',
            message: '',
        };
    };
    // Default props
    EditableTableBasic.defaultProps = {
        enableHtmlEditor: false,
    };
    return EditableTableBasic;
}(React.Component));
exports.EditableTableBasic = EditableTableBasic;
